<template>
  <div>
    <b-card>
      <b-card-header class="text-center"> Tempo de Contribuição </b-card-header>

      <b-table
        striped
        hover
        stacked="md"
        show-empty
        :items="aposentadoria.ContribuicaoAposentadoria"
        :fields="computedFields"
      >
        <template #empty>
          <span>Não foram encontrados resultados.</span>
        </template>
        <template #cell(DtInicial)="data">
          {{ formatData(data.item.DtInicial) }}
        </template>

        <template #cell(DtFinal)="data">
          {{ formatData(data.item.DtFinal) }}
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script lang="ts">
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { Component, Vue } from "vue-property-decorator";
import { PropType } from "vue";
import { Aposentadoria } from "@/types/aposentadoria/aposentadoria";
import { TableField } from "@/types/table-field";

const CompProps = Vue.extend({
  name: "AbaTempoContribuicao",
  props: {
    aposentadoria: {
      type: Object as PropType<Aposentadoria>,
      required: true,
    },
  },
});

@Component
export default class AbaTempoContribuicao extends mixins(UtilsTS, CompProps) {
  //computeds
  get computedFields(): TableField[] {
    const fields: TableField[] = [
      {
        key: "DtInicial",
        label: "Data de início",
        tdClass: "quebrarPorPalavraHard, text-center",
        thClass: "text-center",
      },
      {
        key: "DtFinal",
        label: "Data de Fim",
        tdClass: "quebrarPorPalavraHard, text-center",
        thClass: "text-center",
      },
      {
        key: "IdTipoContribuicaoNavigation.DeTipoContribuicao",
        label: "Tipo de contribuição ",
        tdClass: "quebrarPorPalavraHard, text-center",
        thClass: "text-center",
      },
    ];
    return fields;
  }
}
</script>
